module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi4wNzUiIGhlaWdodD0iMTIuNjY3IiB2aWV3Qm94PSIwIDAgMTYuMDc1IDEyLjY2NyI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ZmZjtzdHJva2U6IzJkMzQzOTtzdHJva2Utd2lkdGg6MnB4O308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTcuNCwyLjEzM2EyLDIsMCwwLDEsMy4yLDBsNSw2LjY2N0EyLDIsMCwwLDEsMTQsMTJINEEyLDIsMCwwLDEsMi40LDguOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3LjAzNyAxMykgcm90YXRlKDE4MCkiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/dark/status/31sleepAhi/01arr.svg
// module id = RWNQ
// module chunks = 0